import { render, staticRenderFns } from "./AdminMessageFeedSection.vue?vue&type=template&id=01c9b372"
import script from "./AdminMessageFeedSection.vue?vue&type=script&lang=js"
export * from "./AdminMessageFeedSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports